// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1624o","type":"styles_type__3EWCD","choices":"styles_choices__3B50_"};